export const HOME = '/';
export const WORK = '/work';
export const STORY = '/story';
export const MUSIC = '/music';
export const CONTACT = '/contact';